// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cellMuted[data-v-08168d84]{color:var(--link-ink-secondary)}.iconPreview[data-v-08168d84]{width:50px;height:50px;-o-object-fit:contain;object-fit:contain;border-radius:8px}", ""]);
// Exports
module.exports = exports;
